const emailValidator = require('email-validator')
const postalValidator = require('postal-codes-js')

const passMatch = (fields) => {
  return(fields.password === fields.password_confirmation)
}

const passMinChar = (fields) => {
  return(fields.password.length > 7)
}

const validPostalCode = (fields, setErrors) => {
  const validity = postalValidator.validate(fields.country_code, fields.postal_code)
  if (validity !== true) {
    setErrors({['postal']: validity})
    return false
  } else {
    return validity
  }
}

const validEmail = (fields) => {
  return(emailValidator.validate(fields.email))
}

const noBasicInfoErrors = (fields) => {
  return(passMatch(fields) && passMinChar(fields) && validEmail(fields))
}

const isWeMeanBusiness = (gon) => {
  return(gon.enrollment.international)
}

export {
  passMatch,
  passMinChar,
  validPostalCode,
  validEmail,
  noBasicInfoErrors,
  isWeMeanBusiness
}
